module.exports = __webpack_public_path__ + "static/img/6.bfcbcc17.png";